export function getCurrentDate ()  {
    const now = new Date();
    let day = now.getDate().toString().padStart(2, '0');
    let month = (now.getMonth() + 1).toString().padStart(2, '0'); // Months are zero indexed
    const year = now.getFullYear();
    return `${year}-${month}-${day}`;
  }